import coinIcon from "src/assets/icons/coin.svg";
import freeIcon from "src/assets/icons/freeCoin.png";
import cn from "classnames";
import { useStyles } from "./styles";

interface IBetProps {
    amount: number;
    isMobile?: boolean;
}

export const Bet = ({ amount, isMobile }: IBetProps) => {
    const classes = useStyles();

    const isFreePlay = document.location.href.indexOf('lobby-free-play') > 0;
    return (
        <div className={classes.wrapperBet}>
            <img src={isFreePlay ? freeIcon : coinIcon} className={classes.coinIcon} />
            <span className={cn(classes.amount, {[classes.amountIsFree]: isFreePlay})}>{amount}</span>
        </div>
    );
};
